import * as React from "react";
import { ProductAttribute } from "./types";
import { AttributeOptionUI } from "./AttributeOptionUI";

export const AttributeSelector: React.FunctionComponent<{
  attributes: ProductAttribute[];
}> = (props) => {
  const options = [...props.attributes];

  return (
    <div className="attribute-list">
      {options.map((option) => {
        return (
          <AttributeOptionUI
            key={option.Id}
            value={option}
            selectType={option.DisplayType}
          ></AttributeOptionUI>
        );
      })}
    </div>
  );
};
